import Select from 'react-select';
import { SearchFieldStyles } from "../Searchfields/SearchFieldStyles";

const options = [
    { value: 0, label: "Em digitação" },
    { value: 1, label: "Pendente de homologação" },
    { value: 2, label: "Revisão" },
    { value: 4, label: "Atualização MIG pendente" },
    { value: 5, label: "Fiscalização pendente" },
    { value: 6, label: "Cancelado" },
    { value: 7, label: "Arquivado" },
    { value: 8, label: "Concluído" }
];

const SituacaoSolCompartilhamento = ({ field, placeholder, name, id, disabled = false }) => {
    return (
        <Select
            options={options}
            {...field}
            styles={SearchFieldStyles}
            placeholder={placeholder}
            name={name}
            isDisabled={disabled}
            id={id}
        />
    )
}

export { SituacaoSolCompartilhamento, options as OpcoesSituacaoSolCompartilhamento }